export const environment = {
  production: false,
  testPermissions: true,
  defaultLanguage: { locale: 'de-DE', name: 'Deutsch' },
  environmentName: 'DEV',
  supportedLanguages: [
    { locale: 'de-DE', name: 'Deutsch' },
    { locale: 'en-US', name: 'English' }
  ]
};
